import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import auth from './auth'

Vue.use(require('vue-moment'))
Vue.config.productionTip = false

Vue.filter('toPascalCase', function(value: string) {
  return (value.match(/[a-zA-Z0-9]+/g) || [])
    .map(w => `${w.charAt(0).toUpperCase()}${w.slice(1)}`)
    .join('')
})

// force login from start
auth.initialize().then(() =>
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app'),
)
